<mat-card *ngIf="translationsLoaded">
  <h3>{{ 'auth.sso.denied.title' | t }}</h3>
  <p>{{ 'auth.sso.denied.message' | t }}</p>
</mat-card>
